var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunnel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.26238 6H26.7374C26.9313 6.00006 27.1211 6.05654 27.2836 6.16254C27.446 6.26855 27.5741 6.41951 27.6523 6.59703C27.7304 6.77456 27.7553 6.97098 27.7238 7.16238C27.6923 7.35378 27.6058 7.53188 27.4749 7.675L19.2624 16.7125C19.0915 16.8955 18.9975 17.1371 18.9999 17.3875V24.4625C19.0014 24.6287 18.961 24.7926 18.8823 24.939C18.8036 25.0854 18.6893 25.2095 18.5499 25.3L14.5499 27.9625C14.3998 28.0613 14.2259 28.1179 14.0465 28.1263C13.867 28.1347 13.6886 28.0945 13.53 28.0101C13.3714 27.9257 13.2384 27.8001 13.1452 27.6466C13.0519 27.493 13.0017 27.3172 12.9999 27.1375V17.3875C13.0023 17.1371 12.9083 16.8955 12.7374 16.7125L4.52488 7.675C4.39395 7.53188 4.30747 7.35378 4.27597 7.16238C4.24447 6.97098 4.26932 6.77456 4.34748 6.59703C4.42565 6.41951 4.55375 6.26855 4.7162 6.16254C4.87864 6.05654 5.06841 6.00006 5.26238 6V6Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/Funnel.e774d4f83a6d336d22f1c2b149ebf26a.svg";
export { ForwardRef as ReactComponent };